import styled from 'styled-components'

const SideBarSize = 78

export const Container = styled.main`
  width: 100vw;
  min-height: calc(100vh - 200px);
  margin-top: 50px;

  color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  @media only screen and (min-width: 800px) {
    padding: 0 1.5rem;

    margin: 40px 32px 0 ${SideBarSize + 32}px;
    padding: 0;

    width: unset;

    /* .desk {
      display: none;
    } */
  }

  .scroll-button {
    position: fixed;
    bottom: 20px;
    right: 20px;
    width: 45px;
    height: 48px;
    background-color: #f9f9f9;
    color: white;
    border-radius: 50%;
    box-shadow: 1px 4px 20px 0px rgba(0, 0, 0, 0.15);
    text-align: center;
    line-height: 50px;
    cursor: pointer;
    transition: opacity 0.5s ease-in-out;
    padding-top: 5px;
    border: none;
  }
`

export const Content = styled.div`
  max-width: 1300px;
  margin: 0 auto;

  .title {
    font-size: 20px;
    font-weight: 700;
    line-height: 30px;
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;

    .icon {
      width: 20px;
      height: 20px;
      cursor: pointer;

      color: rgb(${({ theme }) => theme.primary.base});
    }
  }

  @media only screen and (min-width: 800px) {
    .title {
      font-size: 24px;
      line-height: 28px;
    }

    .questions-count {
      font-size: 14px;
      font-weight: 500;
      line-height: 18px;

      margin-top: 34px;
      margin-left: 38px;
    }
  }
`

export const QuestionsFind = styled.p`
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;

  color: ${({ theme }) => (theme.isDark ? '#A7A7A7' : '#4A4A4A')};

  display: flex;
  align-items: center;
  gap: 4px;

  margin-top: 24px;
  margin-left: 18px;

  .loading-block {
    display: inline-block;
    width: 225px;
    height: 18px;
  }

  @media only screen and (min-width: 800px) {
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;

    margin-top: 16px;
    margin-left: 40px;
  }
`

export const Group = styled.div`
  padding: 0 1.5rem;

  .divBeta {
    margin: 0;
    margin-bottom: 24px;
    display: flex;
    align-items: center;

    .beta {
      border-radius: 2px;
      align-items: center;
      padding: 2px;
      font-family: 'Montserrat';
      font-size: 12px;
      font-weight: 700;
      line-height: 16px;
      text-align: center;
      width: 42px;
      height: 20px;
      background-color: ${({ theme }) =>
        theme.isDark ? 'rgba(8, 137, 198, 1)' : 'rgba(50, 183, 246, 0.3)'};
      color: ${({ theme }) => (theme.isDark ? 'rgba(182, 229, 252, 1)' : 'rgba(5, 81, 117, 1)')};
      margin-left: 10px;
      margin-bottom: 10px;
    }

    h1 {
      margin: 0px;
    }
  }
`

export const PaginationFooter = styled.div`
  display: none;

  @media only screen and (min-width: 800px) {
    margin-top: 28.1px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`
